/**
 * Compatibility Layer Module
 *
 * Exports Angular 15 equivalents for Angular 16+ features.
 */

import { NgModule } from '@angular/core';

// Export polyfills and operators
export { DestroyRefPolyfill } from './destroy-ref.polyfill';
export { takeUntilDestroyed, takeUntilDestroyed$ } from './take-until-destroyed.operator';

/**
 * CompatibilityLayerModule
 *
 * Module that provides compatibility utilities for Angular 15.
 * Import this module to access polyfills for Angular 16+ features.
 *
 * Usage:
 * ```typescript
 * @NgModule({
 *   imports: [CompatibilityLayerModule]
 * })
 * export class MyModule { }
 * ```
 */
@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class CompatibilityLayerModule {
  static forRoot() {
    return {
      ngModule: CompatibilityLayerModule,
      providers: []
    };
  }
}
